module.exports = __webpack_public_path__ + "images/2752475904d513cef3f1ba878751381d.png";